import React from 'react';
import { Text } from '@ui/atoms/Text';
import { buildingPath } from '@routes';
export function BuildingCell({ item }) {
    if (!item.buildingId) {
        return React.createElement(Text, null, item.building);
    }
    return (React.createElement(Text, { variant: "link", as: "a", href: buildingPath(item.buildingId), target: "_blank", rel: "noopener noreferrer" }, item.building));
}
